import { useState } from 'react'
import type { TipoObjetoTabletop } from '../../../dominio/tabletop'

const CATEGORIAS: readonly {
  nome: string
  tipos: readonly TipoObjetoTabletop[]
}[] = [
  {
    nome: 'Veículos',
    tipos: [
      'caminhaoTanque',
      'carro',
      'viaturaAbt',
      'viaturaHazmat',
      'ambulancia',
    ],
  },
  {
    nome: 'Pessoas',
    tipos: ['bombeiroNivelA', 'bombeiroNivelB', 'bombeiroNivelC', 'bombeiroIncendio', 'medico', 'vitima'],
  },
  {
    nome: 'Riscos',
    tipos: ['vazamento', 'liquidoDerramado', 'fogo', 'fogoTanque', 'bleve', 'curtoCircuito'],
  },
  {
    nome: 'Estruturas e ambiente',
    tipos: ['predio', 'escola', 'hospital', 'corrego', 'bueiro'],
  },
  {
    nome: 'Apoio e isolamento',
    tipos: [
      'cone',
      'fita',
      'postoComando',
      'areaVitimas',
      'corredorDescontaminacao',
      'biruta',
    ],
  },
]

/** Miniaturas vetoriais leves: não abrem canvases WebGL no catálogo. */
function Miniatura({ tipo }: { tipo: TipoObjetoTabletop }) {
  const veiculo = CATEGORIAS[0]!.tipos.includes(tipo)
  const pessoa = CATEGORIAS[1]!.tipos.includes(tipo)
  const risco = CATEGORIAS[2]!.tipos.includes(tipo)
  const corPessoa = tipo === 'bombeiroNivelC' ? '#f2f3ef' : tipo === 'bombeiroNivelB' ? '#76b689' : ['bombeiroIncendio', 'medico'].includes(tipo) ? '#a16207' : '#d8b642'
  const nivel = tipo.endsWith('A') ? 'A' : tipo.endsWith('B') ? 'B' : 'C'
  return (
    <svg viewBox="0 0 96 64" aria-hidden="true" className="mesa-miniatura">
      {veiculo ? (
        <>
          <rect
            x="16"
            y={tipo === 'carro' ? 31 : 20}
            width="64"
            height={tipo === 'carro' ? 17 : 28}
            rx="5"
            fill={
              tipo.startsWith('viatura')
                ? '#bc4742'
                : tipo === 'ambulancia'
                  ? '#bc4742'
                  : '#82929f'
            }
          />
          {tipo === 'carro' ? (
            <>
              <path d="M30 31l9-13h22l12 13z" fill="#82929f" />
              <path d="M36 29l6-8h16l8 8z" fill="#294451" />
            </>
          ) : (
            <rect x="20" y="24" width="18" height="12" rx="3" fill="#294451" />
          )}
          <circle cx="30" cy="49" r="7" fill="#202b36" />
          <circle cx="68" cy="49" r="7" fill="#202b36" />
          {tipo === 'caminhaoTanque' && (
            <rect x="42" y="14" width="35" height="27" rx="12" fill="#d8dde2" />
          )}
          {tipo === 'ambulancia' && (
            <path d="M61 24v17M53 32h16" stroke="#f2f3ef" strokeWidth="5" />
          )}
          {(tipo.startsWith('viatura') || tipo === 'ambulancia') && (
            <rect x="22" y="16" width="16" height="4" fill="#73c6ed" />
          )}
        </>
      ) : pessoa ? (
        <g
          transform={
            tipo === 'vitima' ? 'translate(76 2) rotate(90)' : undefined
          }
        >
          <circle
            cx="48"
            cy="15"
            r="8"
            fill={tipo === 'vitima' ? '#ddb18b' : corPessoa}
          />
          <path
            d="M36 28h24v18H36z"
            fill={tipo === 'vitima' ? '#5491be' : corPessoa}
          />
          <path
            d="M38 45v14M58 45v14M34 28l-8 17M62 28l8 17"
            stroke={tipo === 'vitima' ? '#5491be' : corPessoa}
            strokeWidth="7"
          />
          {tipo.startsWith('bombeiroNivel') && (
            <text
              x="48"
              y="41"
              textAnchor="middle"
              fill="#18212b"
              fontSize="15"
              fontWeight="bold"
            >
              {nivel}
            </text>
          )}
          {['bombeiroIncendio', 'medico'].includes(tipo) && (
            <>
              <path d="M37 15a11 11 0 0 1 22 0zM35 15h26" fill={tipo === 'medico' ? '#f8fafc' : '#dc2626'} stroke={tipo === 'medico' ? '#f8fafc' : '#dc2626'} strokeWidth="3" />
              <path d="M36 33h24M36 43h24" stroke="#fef08a" strokeWidth="3" />
              {tipo === 'medico' && <path d="M66 41v11M61 46h10" stroke="#f8fafc" strokeWidth="3" />}
            </>
          )}
        </g>
      ) : risco ? (
        tipo === 'curtoCircuito' ? (
          <><rect x="28" y="30" width="38" height="23" fill="#48525c" /><path d="M54 8L38 29h14L42 47l24-26H52z" fill="#ffe07a" /></>
        ) : tipo === 'bleve' ? (
          <><circle cx="48" cy="30" r="23" fill="#f46c22" /><circle cx="48" cy="30" r="15" fill="#ffdb68" /><path d="M28 56h40" stroke="#82929f" strokeWidth="5" /></>
        ) : tipo === 'fogo' || tipo === 'fogoTanque' ? (
          <><path d="M48 6C60 27 77 33 63 52C51 65 25 55 29 39C31 29 39 26 39 16C44 23 47 28 48 6" fill="#f46c22" /><path d="M48 29C59 41 58 56 46 56C33 55 39 43 48 29" fill="#ffdb68" />{tipo === 'fogoTanque' && <rect x="20" y="52" width="56" height="9" rx="4" fill="#82929f" />}</>
        ) : (
          <><ellipse cx="48" cy="49" rx="32" ry="9" fill="#528b83" />{tipo === 'vazamento' && <><path d="M32 15h18v12" fill="none" stroke="#82929f" strokeWidth="8" /><path d="M50 29v15" stroke="#91d5d6" strokeWidth="5" strokeDasharray="4 3" /></>}</>
        )
      ) : tipo === 'cone' ? (
        <path d="M48 10L30 52h36z" fill="#f29c38" />
      ) : tipo === 'fita' ? (
        <>
          <path d="M15 19v36M81 19v36" stroke="#82929f" strokeWidth="5" />
          <path
            d="M15 26h66"
            stroke="#f4ce54"
            strokeWidth="9"
            strokeDasharray="10 3"
          />
        </>
      ) : tipo === 'corrego' ? (
        <path
          d="M5 23Q25 5 48 25T91 25M5 42Q25 24 48 44T91 44"
          fill="none"
          stroke="#65afd2"
          strokeWidth="9"
        />
      ) : tipo === 'bueiro' ? (
        <>
          <rect x="17" y="20" width="62" height="28" rx="5" fill="#536575" />
          <path
            d="M26 23v22M37 23v22M48 23v22M59 23v22M70 23v22"
            stroke="#18212b"
            strokeWidth="4"
          />
        </>
      ) : tipo === 'biruta' ? (
        <>
          <path d="M25 12v44" stroke="#c4ced5" strokeWidth="4" />
          <path d="M27 13l52 10-52 5z" fill="#ef9754" />
        </>
      ) : ['predio', 'escola', 'hospital'].includes(tipo) ? (
        <>
          <rect x="19" y="12" width="58" height="43" fill="#aab8c1" />
          <path
            d="M29 24h9M49 24h9M29 38h9M49 38h9"
            stroke="#294451"
            strokeWidth="7"
          />
          {tipo === 'hospital' && (
            <path d="M68 15v13M62 21h12" stroke="#dc4545" strokeWidth="3" />
          )}
        </>
      ) : tipo === 'corredorDescontaminacao' ? (
        <path
          d="M22 54V15h52v39M31 26h34"
          fill="none"
          stroke="#65afd2"
          strokeWidth="7"
        />
      ) : tipo === 'areaVitimas' ? (
        <>
          <rect x="18" y="18" width="60" height="28" fill="#65a58b" />
          <path d="M18 12v42M78 12v42" stroke="#c4ced5" strokeWidth="5" />
        </>
      ) : (
        <>
          <path d="M13 30l35-24 35 24z" fill="#65a58b" />
          <path d="M20 30v26M76 30v26" stroke="#c4ced5" strokeWidth="5" />
        </>
      )}
    </svg>
  )
}

export function CatalogoObjetosMesa({
  nomeTipo,
  aoEscolher,
}: {
  nomeTipo: (tipo: TipoObjetoTabletop) => string
  aoEscolher: (tipo: TipoObjetoTabletop) => void
}) {
  const [busca, setBusca] = useState('')
  const normalizar = (s: string) =>
    s
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase('pt-BR')
  const categorias = CATEGORIAS.map((c) => ({
    ...c,
    tipos: c.tipos.filter((t) =>
      normalizar(nomeTipo(t)).includes(normalizar(busca)),
    ),
  })).filter((c) => c.tipos.length)
  return (
    <div className="mesa-catalogo">
      <label className="campo">
        Buscar item
        <input
          type="search"
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
        />
      </label>
      {categorias.map((c) => (
        <fieldset key={c.nome}>
          <legend>{c.nome}</legend>
          {c.nome === 'Riscos' && (
            <p>Clique perto do tanque para encaixar fogo, vazamento ou BLEVE. Também podem ficar livres. Configure produto e situação na fonte para calcular as zonas de risco.</p>
          )}
          <div className="mesa-catalogo__itens">
            {c.tipos.map((tipo) => (
              <button
                key={tipo}
                type="button"
                className="btn-acao-cad btn-acao-cad--secundario"
                aria-label={`Posicionar ${nomeTipo(tipo)}`}
                onClick={() => aoEscolher(tipo)}
              >
                <Miniatura tipo={tipo} />
                <span>{nomeTipo(tipo)}</span>
              </button>
            ))}
          </div>
        </fieldset>
      ))}
      {!categorias.length && <p role="status">Nenhum item encontrado.</p>}
    </div>
  )
}
